var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatIndentIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5H17.5V15.8333H2.5V17.5ZM2.5 6.66667V13.3333L5.83333 10L2.5 6.66667ZM9.16667 14.1667H17.5V12.5H9.16667V14.1667ZM2.5 2.5V4.16667H17.5V2.5H2.5ZM9.16667 7.5H17.5V5.83333H9.16667V7.5ZM9.16667 10.8333H17.5V9.16667H9.16667V10.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatIndentIncrease);
export default __webpack_public_path__ + "static/media/format_indent_increase.94b2dc81f353eda6ea719127affe2281.svg";
export { ForwardRef as ReactComponent };